"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const amount_1 = require("./amount");
function convertPlanckToAssetPrice(planck, decimals) {
    return amount_1.Amount.fromSigna(planck).divide(Math.pow(10, decimals)).getSigna();
}
exports.convertPlanckToAssetPrice = convertPlanckToAssetPrice;
//# sourceMappingURL=convertPlanckToAssetPrice.js.map